<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">
    
    <div v-if="!loading" style="text-align: left; color: #666;" class="d-flex align-items-center justify-content-center">
      <form @submit.prevent="save_config">
        <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
          <tr data-field="views_reports_enabled">
            <td align="right" width="500">Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_payroll_notes_enabled">
            <td align="right" width="500">Payroll Notes Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_payroll_notes_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_overnight_hour_offset">
            <td align="right" width="500">Overnight Hours Offset</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_overnight_hour_offset" type="text" :state="numericState('views_reports_overnight_hour_offset')" @input="validateNumeric('views_reports_overnight_hour_offset', $event, 0, 23)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_overnight_hour_offset')">{{ numericFeedback('views_reports_overnight_hour_offset') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_vehicle_report_start_min_planned">
            <td align="right" width="500">Report Start Min Planned</td>
            <td width="500"><b-form-select v-model="model.views_reports_vehicle_report_start_min_planned" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_vehicle_report_start_stop_private_only">
            <td align="right" width="500">Start Stop Private Only</td>
            <td width="500"><b-form-select v-model="model.views_reports_vehicle_report_start_stop_private_only" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_vehicle_report_start_stop_contract_only">
            <td align="right" width="500">Start Stop Contract Only</td>
            <td width="500"><b-form-select v-model="model.views_reports_vehicle_report_start_stop_contract_only" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_vehicle_report_start_stop_columns">
            <td align="right" width="500">Start Stop Columns</td>
            <td width="500"><b-form-input v-model="model.views_reports_vehicle_report_start_stop_columns" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_vehicle_type_filter">
            <td align="right" width="500">Vehicle Type Filter</td>
            <td width="500"><b-form-input v-model="model.views_reports_vehicle_type_filter" type="text" :state="filterState('views_reports_vehicle_type_filter')" @input="validateFilter('views_reports_vehicle_type_filter', $event)"></b-form-input>
                <b-form-invalid-feedback :state="filterState('views_reports_vehicle_type_filter')">{{ filterFeedback('views_reports_vehicle_type_filter') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_payroll_company">
            <td align="right" width="500">Payroll Company</td>
            <td width="500"><b-form-input v-model="model.views_reports_payroll_company" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_payroll_company === 'paycom'" data-field="views_reports_paycom_terminal_group_compensation">
            <td align="right" width="500">Paycom Terminal Group Timezone (hours)</td>
            <td width="800"><JsonKeyValueEditor v-model="model.views_reports_paycom_terminal_group_compensation" fieldKey="views_reports_paycom_terminal_group_compensation" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" keyLabel="Terminal Group" valueLabel="Hours Offset" valueType="number" keyPlaceholder="e.g. DRI" valuePlaceholder="e.g. 2"/>
                <b-form-invalid-feedback :state="jsonState('views_reports_paycom_terminal_group_compensation')">{{ jsonFeedback('views_reports_paycom_terminal_group_compensation') }}</b-form-invalid-feedback></td>
            <td width="250" style="font-size: 12px; color: #888;">Terminal group code → hours to add to CST for local time. Leave blank for no offset.</td>
          </tr>
          <tr v-if="user.tenant == 'starline-tbn-bdc7f899'" data-field="views_reports_payroll_categories">
            <td align="right" width="500">Payroll Categories</td>
            <td width="500"><b-form-input v-model="model.views_reports_payroll_categories" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'starline-tbn-bdc7f899'" data-field="views_reports_payroll_category_report_config">
            <td align="right" width="500">Payroll Report Config</td>
            <td width="800"><JsonObjectListEditor v-model="model.views_reports_payroll_category_report_config" fieldKey="views_reports_payroll_category_report_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="payroll_category_report_columns"/>
                <b-form-invalid-feedback :state="jsonState('views_reports_payroll_category_report_config')">{{ jsonFeedback('views_reports_payroll_category_report_config') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_vehicle_report_start_threshold_minutes">
            <td align="right" width="500">Start Threshold Minutes</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_vehicle_report_start_threshold_minutes" type="text" :state="numericState('views_reports_vehicle_report_start_threshold_minutes')" @input="validateNumeric('views_reports_vehicle_report_start_threshold_minutes', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_vehicle_report_start_threshold_minutes')">{{ numericFeedback('views_reports_vehicle_report_start_threshold_minutes') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_vehicle_report_start_offset_minutes">
            <td align="right" width="500">Start Offset Minutes</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_vehicle_report_start_offset_minutes" type="text" :state="numericState('views_reports_vehicle_report_start_offset_minutes')" @input="validateNumeric('views_reports_vehicle_report_start_offset_minutes', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_vehicle_report_start_offset_minutes')">{{ numericFeedback('views_reports_vehicle_report_start_offset_minutes') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_vehicle_report_finish_offset_minutes">
            <td align="right" width="500">Finish Offset Minutes</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_vehicle_report_finish_offset_minutes" type="text" :state="numericState('views_reports_vehicle_report_finish_offset_minutes')" @input="validateNumeric('views_reports_vehicle_report_finish_offset_minutes', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_vehicle_report_finish_offset_minutes')">{{ numericFeedback('views_reports_vehicle_report_finish_offset_minutes') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_vehicle_report_round_to_minutes">
            <td align="right" width="500">Round To Nearest Minutes</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_vehicle_report_round_to_minutes" type="text" :state="numericState('views_reports_vehicle_report_round_to_minutes')" @input="validateNumeric('views_reports_vehicle_report_round_to_minutes', $event, 0, 60)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_vehicle_report_round_to_minutes')">{{ numericFeedback('views_reports_vehicle_report_round_to_minutes') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_driver_payroll_push_enabled">
            <td align="right" width="500">Payroll Push Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_driver_payroll_push_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_driver_payroll_push_bookings_enabled">
            <td align="right" width="500">Payroll Push Bookings Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_driver_payroll_push_bookings_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_driver_payroll_use_planned_start_as_actual">
            <td align="right" width="500">Payroll Use Planned Start As Actual</td>
            <td width="500"><b-form-select v-model="model.views_reports_driver_payroll_use_planned_start_as_actual" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_driver_payroll_max_off_duty_gap">
            <td align="right" width="500">Payroll Max Off Duty Gap</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_driver_payroll_max_off_duty_gap" type="text" :state="numericState('views_reports_driver_payroll_max_off_duty_gap')" @input="validateNumeric('views_reports_driver_payroll_max_off_duty_gap', $event, 0, 24)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_driver_payroll_max_off_duty_gap')">{{ numericFeedback('views_reports_driver_payroll_max_off_duty_gap') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_driver_payroll_minimum_hours">
            <td align="right" width="500">Payroll Minimum Hours</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_driver_payroll_minimum_hours" type="text" :state="numericState('views_reports_driver_payroll_minimum_hours')" @input="validateNumeric('views_reports_driver_payroll_minimum_hours', $event, 0, 24)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_driver_payroll_minimum_hours')">{{ numericFeedback('views_reports_driver_payroll_minimum_hours') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_driver_payroll_middle_day_min_hours">
            <td align="right" width="500">Payroll Middle Day Min Hours</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_driver_payroll_middle_day_min_hours" type="text" :state="numericState('views_reports_driver_payroll_middle_day_min_hours')" @input="validateNumeric('views_reports_driver_payroll_middle_day_min_hours', $event, 0, 24)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_driver_payroll_middle_day_min_hours')">{{ numericFeedback('views_reports_driver_payroll_middle_day_min_hours') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'mtrwestern-tbn-3db5da5g7'" data-field="views_reports_driver_payroll_los_mappings">
            <td align="right" width="500">Payroll LOS Mappings</td>
            <td width="500"><b-form-input v-model="model.views_reports_driver_payroll_los_mappings" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'mtrwestern-tbn-3db5da5g7'" data-field="views_reports_driver_payroll_ski_client_ids">
            <td align="right" width="500">Payroll Ski Client IDs</td>
            <td width="500"><b-form-input v-model="model.views_reports_driver_payroll_ski_client_ids" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'mtrwestern-tbn-3db5da5g7'" data-field="views_reports_driver_payroll_push_filter">
            <td align="right" width="500">Payroll Push Filter</td>
            <td width="500"><b-form-input v-model="model.views_reports_driver_payroll_push_filter" type="text" :state="filterState('views_reports_driver_payroll_push_filter')" @input="validateFilter('views_reports_driver_payroll_push_filter', $event)"></b-form-input>
                <b-form-invalid-feedback :state="filterState('views_reports_driver_payroll_push_filter')">{{ filterFeedback('views_reports_driver_payroll_push_filter') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="telematics_type == 'SAMSARA'" data-field="views_reports_payroll_summary_samsara_username_enabled">
            <td align="right" width="500">Payroll Summary Samsara Username Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_payroll_summary_samsara_username_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250" style="font-size: 12px; color: #888;">Show Samsara username as 2nd column in the Payroll Summary Report</td>
          </tr>
          <tr data-field="views_reports_payroll_summary_vehicles_to_exclude">
            <td align="right" width="500">Payroll Summary Vehicles To Exclude</td>
            <td width="500"><b-form-input v-model="model.views_reports_payroll_summary_vehicles_to_exclude" type="text"></b-form-input></td>
            <td width="250" style="font-size: 12px; color: #888;">Comma-delimited vehicle names; matching HOS events are excluded from Payroll Summary totals (case insensitive)</td>
          </tr>
          <tr data-field="views_reports_payroll_summary_remarks_to_exclude">
            <td align="right" width="500">Payroll Summary Remarks To Exclude</td>
            <td width="500"><b-form-input v-model="model.views_reports_payroll_summary_remarks_to_exclude" type="text"></b-form-input></td>
            <td width="250" style="font-size: 12px; color: #888;">Comma-delimited HOS remarks; matching events are excluded from Payroll Summary totals (case insensitive)</td>
          </tr>
          <tr data-field="views_reports_hos_nightly_report_config">
            <td align="right" width="500">HOS Nightly Report Config</td>
            <td width="500"><JsonObjectListEditor v-model="model.views_reports_hos_nightly_report_config" fieldKey="views_reports_hos_nightly_report_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="hos_nightly_report_columns"/>
                <b-form-invalid-feedback :state="jsonState('views_reports_hos_nightly_report_config')">{{ jsonFeedback('views_reports_hos_nightly_report_config') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_nightly_alerts_report_config">
            <td align="right" width="500">Nightly Alerts Report Config</td>
            <td width="500"><JsonObjectListEditor v-model="model.views_reports_nightly_alerts_report_config" fieldKey="views_reports_nightly_alerts_report_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="nightly_alerts_report_columns"/>
                <b-form-invalid-feedback :state="jsonState('views_reports_nightly_alerts_report_config')">{{ jsonFeedback('views_reports_nightly_alerts_report_config') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_nightly_report_config">
            <td align="right" width="500">Nightly Report Config</td>
            <td width="500"><JsonObjectListEditor v-model="model.views_reports_nightly_report_config" fieldKey="views_reports_nightly_report_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="nightly_report_columns"/>
                <b-form-invalid-feedback :state="jsonState('views_reports_nightly_report_config')">{{ jsonFeedback('views_reports_nightly_report_config') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_otp_report_enabled">
            <td align="right" width="500">OTP Report Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_use_same_spot_and_pickup">
            <td align="right" width="500">OTP Report Use Same Spot & Pickup</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_use_same_spot_and_pickup" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_stop_notes_enabled">
            <td align="right" width="500">OTP Stop Notes Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_stop_notes_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_arrivals_enabled">
            <td align="right" width="500">OTP Stop Arrivals Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_arrivals_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_adjust_stop_timezones">
            <td align="right" width="500">OTP Adjust Stop Timezones</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_adjust_stop_timezones" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_portico_enabled">
            <td align="right" width="500">OTP Report Portico Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_portico_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_skip_first_and_last_stop_enabled">
            <td align="right" width="500">OTP Skip First & Last Stop</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_skip_first_and_last_stop_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_email_recipients">
            <td align="right" width="500">OTP Email Recipients</td>
            <td width="500"><b-form-input v-model="model.views_reports_otp_report_email_recipients" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_include_drivers_enabled">
            <td align="right" width="500">OTP Include Drivers</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_include_drivers_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_use_driver_assignments_enabled">
            <td align="right" width="500">OTP Use Driver Assignments To Vehicles</td>
            <td width="500"><b-form-select v-model="model.views_reports_otp_report_use_driver_assignments_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_arrival_early_minutes_limit">
            <td align="right" width="500">OTP Report Arrival Early Minutes Limit</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_otp_report_arrival_early_minutes_limit" type="text" :state="numericState('views_reports_otp_report_arrival_early_minutes_limit')" @input="validateNumeric('views_reports_otp_report_arrival_early_minutes_limit', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_otp_report_arrival_early_minutes_limit')">{{ numericFeedback('views_reports_otp_report_arrival_early_minutes_limit') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_arrival_late_minutes_limit">
            <td align="right" width="500">OTP Report Arrival Late Minutes Limit</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_otp_report_arrival_late_minutes_limit" type="text" :state="numericState('views_reports_otp_report_arrival_late_minutes_limit')" @input="validateNumeric('views_reports_otp_report_arrival_late_minutes_limit', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_otp_report_arrival_late_minutes_limit')">{{ numericFeedback('views_reports_otp_report_arrival_late_minutes_limit') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_departure_early_minutes_limit">
            <td align="right" width="500">OTP Report Departure Early Minutes Limit</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_otp_report_departure_early_minutes_limit" type="text" :state="numericState('views_reports_otp_report_departure_early_minutes_limit')" @input="validateNumeric('views_reports_otp_report_departure_early_minutes_limit', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_otp_report_departure_early_minutes_limit')">{{ numericFeedback('views_reports_otp_report_departure_early_minutes_limit') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_departure_late_minutes_limit">
            <td align="right" width="500">OTP Report Departure Late Minutes Limit</td>
            <td width="500">
              <b-form-input v-model="model.views_reports_otp_report_departure_late_minutes_limit" type="text" :state="numericState('views_reports_otp_report_departure_late_minutes_limit')" @input="validateNumeric('views_reports_otp_report_departure_late_minutes_limit', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('views_reports_otp_report_departure_late_minutes_limit')">{{ numericFeedback('views_reports_otp_report_departure_late_minutes_limit') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_send_filter_at_time">
            <td align="right" width="500">OTP Report Send Filter At Time</td>
            <td width="500"><b-form-input v-model="model.views_reports_otp_report_send_filter_at_time" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="views_reports_otp_report_multiday_config">
            <td align="right" width="500">OTP Report Multiday Config</td>
            <td width="500"><JsonTagListEditor v-model="model.views_reports_otp_report_multiday_config" fieldKey="views_reports_otp_report_multiday_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" valueLabel="Day Config" placeholder="e.g. 1"/>
                <b-form-invalid-feedback :state="jsonState('views_reports_otp_report_multiday_config')">{{ jsonFeedback('views_reports_otp_report_multiday_config') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="routes_charter_filter">
            <td align="right" width="500">OTP Routes Charter Filter</td>
            <td width="500"><b-form-input v-model="model.routes_charter_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="routes_company_filter">
            <td align="right" width="500">OTP Routes Company Filter</td>
            <td width="500"><b-form-input v-model="model.routes_company_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="routes_filter">
            <td align="right" width="500">OTP Routes Filter</td>
            <td width="500"><b-form-input v-model="model.routes_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="routes_type_filter">
            <td align="right" width="500">OTP Routes Type Filter</td>
            <td width="500"><b-form-input v-model="model.routes_type_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.views_reports_otp_report_enabled" data-field="routes_name_field">
            <td align="right" width="500">OTP Routes Name Field</td>
            <td width="500"><b-form-input v-model="model.routes_name_field" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'polyad-9a91d945'" data-field="views_reports_process_trip_sheets_doc_type">
            <td align="right" width="500">Process Trip Sheets Doc Type</td>
            <td width="500"><b-form-input v-model="model.views_reports_process_trip_sheets_doc_type" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'polyad-9a91d945'" data-field="views_reports_process_trip_sheets_email_recipients">
            <td align="right" width="500">Process Trip Sheets Email Recipients</td>
            <td width="500"><b-form-input v-model="model.views_reports_process_trip_sheets_email_recipients" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'" data-field="views_reports_dispatch_board_visible_fields">
            <td align="right" width="500">Dispatch Board Visible Fields</td>
            <td width="500"><b-form-input v-model="model.views_reports_dispatch_board_visible_fields" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_trip_sheet_visible_fields">
            <td align="right" width="500">Trip Sheet Visible Fields</td>
            <td width="500"><b-form-input v-model="model.views_reports_trip_sheet_visible_fields" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_process_trip_sheets_enabled">
            <td align="right" width="500">Trip Sheets Enabed</td>
            <td width="500"><b-form-select v-model="model.views_reports_process_trip_sheets_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'" data-field="views_reports_dispatch_board_current_departures_only">
            <td align="right" width="500">Dispatch Board Current Departures Only</td>
            <td width="500"><b-form-select v-model="model.views_reports_dispatch_board_current_departures_only" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'" data-field="views_reports_intrastate_skip_routes">
            <td align="right" width="500">Intrastate Report Skip Route Names</td>
            <td width="500"><b-form-textarea v-model="model.views_reports_intrastate_skip_routes" style="field-sizing: content"/></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="telematics_type == 'SAMSARA'" data-field="views_reports_samsara_safety_report_enabled">
            <td align="right" width="500">Samsara Safety Report Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_samsara_safety_report_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="telematics_type == 'SAMSARA'" data-field="views_reports_samsara_vehicle_mileage_enabled">
            <td align="right" width="500">Samsara Vehicle Mileage Enabled</td>
            <td width="500"><b-form-select v-model="model.views_reports_samsara_vehicle_mileage_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="views_reports_veh_monthly_type_mappings">
            <td align="right" width="500">Vehicle Monthly Type Mappings</td>
            <td width="500"><JsonKeyValueEditor v-model="model.views_reports_veh_monthly_type_mappings" fieldKey="views_reports_veh_monthly_type_mappings" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" keyLabel="Vehicle Type" valueLabel="Report Category"/>
                <b-form-invalid-feedback :state="jsonState('views_reports_veh_monthly_type_mappings')">{{ jsonFeedback('views_reports_veh_monthly_type_mappings') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="isEffectiveAdmin">
            <td align="right"><span style="color: var(--fi-rail-accent); font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isAdvVisible')">{{ toggle.isAdvVisible ? "▾" : "▸" }} Advanced</span></td>
            <td></td>
            <td></td>
          </tr>
          <template v-if="toggle.isAdvVisible">
            <tr data-field="employee_id_matching_enabled">
              <td align="right" width="500">Employee ID Matching Enabled</td>
              <td width="500"><b-form-select v-model="model.employee_id_matching_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250" style="font-size: 12px; color: #888;">Match by ID (TBN Ref ID / Samsara Username / Paycom eecode) instead of name</td>
            </tr>
          </template>
        </table>


      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  <div class="tc-sticky-save">
    <transition name="tc-save-slide">
    <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
      <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
      <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
      &nbsp;&nbsp;
      <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
    </div>
    </transition>
  </div>
</div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import filterValidationMixin from '../mixins/filter_validation_mixin'
import {mapState} from "vuex";
import numericValidationMixin from '../mixins/numeric_validation_mixin'
import jsonValidationMixin from '../mixins/json_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'
import JsonKeyValueEditor from './JsonKeyValueEditor.vue'
import JsonTagListEditor from './JsonTagListEditor.vue'
import JsonObjectListEditor from './JsonObjectListEditor.vue'

export default {
  name: 'tenant_config',
  mixins: [filterValidationMixin, numericValidationMixin, jsonValidationMixin, dirtyTrackingMixin],
  components: {
    JsonKeyValueEditor,
    JsonTagListEditor,
    JsonObjectListEditor,
  },

  data() {
    return {
      group_name: 'general',
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {},
      summary: {},
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      objectKeyList:[],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      payroll_category_report_columns: [
        { key: 'category', label: 'Category', placeholder: 'e.g. Maintenance' },
        { key: 'email_recipients', label: 'Email Recipients', placeholder: 'comma-separated emails' },
      ],
      hos_nightly_report_columns: [
        { key: 'report_name', label: 'Report Name', placeholder: 'e.g. Main' },
        { key: 'selected_driver', label: 'Driver Filter', placeholder: 'optional' },
        { key: 'selected_status', label: 'Status Filter', placeholder: 'optional' },
        { key: 'remarks_filter', label: 'Remarks Filter', placeholder: 'optional' },
        { key: 'email_recipients', label: 'Email Recipients', placeholder: 'comma-separated emails' },
      ],
      nightly_alerts_report_columns: [
        { key: 'report_name', label: 'Report Name', placeholder: 'e.g. Late Alerts' },
        { key: 'alert_type', label: 'Alert Type', placeholder: 'e.g. LateAlert' },
        { key: 'alert_filter', label: 'Alert Filter', placeholder: 'optional' },
        { key: 'start_base', label: 'Start Base', placeholder: 'optional' },
        { key: 'email_recipients', label: 'Email Recipients', placeholder: 'comma-separated emails' },
      ],
      nightly_report_columns: [
        { key: 'report_type', label: 'Report Type', placeholder: 'e.g. OTP' },
        { key: 'email_recipients', label: 'Email Recipients', placeholder: 'comma-separated emails' },
      ],
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data(silent = false) {
      if (!silent) this.loading = true
      this.objectKeyList = []
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
      this._resetDirtyTracking()
    },
    async save_config() {
      try {
        this.saving = true
        this.flushNumericValidation()
        this.flushFilterValidation()
        if (this.hasNumericErrors()) {
          this.$emit('showAlert', 'Fix the highlighted field before saving', 'danger', 6000)
          this.scrollToFirstNumericError()
          return
        }
        if (this.hasFilterErrors()) {
          this.$emit('showAlert', 'Fix the highlighted filter field before saving', 'danger', 6000)
          this.scrollToFirstFilterError()
          return
        }
        if (this.hasJsonErrors()) {
          this.$emit('showAlert', 'Invalid JSON in field: ' + this.firstJsonErrorKey() + ' — ' + this.jsonFeedback(this.firstJsonErrorKey()), 'danger', 8000)
          this.expandAndScrollToJsonError()
          return
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        for (const objkey of this.objectKeyList) {
          try {
            if (this.model[objkey] && this.model[objkey].trim && this.model[objkey].trim() !== '') {
              let setting = JSON.parse(this.model[objkey])
              this.model[objkey] = setting
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.expandAndScrollToJsonError()
            this.load_data()
            return
          }
        }
        await update_tenant_config_settings(this.user.tenant, this.model, this.group_name)
        this._resetDirtyTracking()
        this.load_data(true)
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      finally {
        this.saving = false
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    isEffectiveAdmin() {
      return this.user.role === 'admin' && this.viewAs !== 'non-admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

